import SvgWrapper from './SvgWrapper';
import { AllergnIconProps } from './types';

const MolluscIcon = ({
  innerColor = '#fefefe',
  outerColor = '#03b2c7',
  ...props
}: AllergnIconProps) => {
  return (
    <SvgWrapper {...props}>
      <g
        id="Grupo_126"
        data-name="Grupo 126"
        transform="translate(-17.851 -2094)"
      >
        <g
          id="Rectángulo_13"
          data-name="Rectángulo 13"
          transform="translate(17.851 2094)"
          fill="#fff"
          stroke="#000"
          stroke-width="1"
        >
          <rect width="27" height="27" rx="2" stroke="none" />
          <rect x="0.5" y="0.5" width="26" height="26" rx="1.5" fill="none" />
        </g>
        <g id="shell" transform="translate(23.598 2101.136)">
          <g
            id="Grupo_98"
            data-name="Grupo 98"
            transform="translate(8.363 7.273)"
          >
            <g id="Grupo_97" data-name="Grupo 97">
              <path
                id="Trazado_9099"
                data-name="Trazado 9099"
                d="M276.455,286.017a.3.3,0,1,0,.3.3A.3.3,0,0,0,276.455,286.017Z"
                transform="translate(-276.152 -286.017)"
              />
            </g>
          </g>
          <g
            id="Grupo_100"
            data-name="Grupo 100"
            transform="translate(6.545 7.273)"
          >
            <g id="Grupo_99" data-name="Grupo 99">
              <path
                id="Trazado_9100"
                data-name="Trazado 9100"
                d="M216.418,286.017a.3.3,0,1,0,.3.3A.3.3,0,0,0,216.418,286.017Z"
                transform="translate(-216.115 -286.017)"
              />
            </g>
          </g>
          <g id="Grupo_102" data-name="Grupo 102" transform="translate(0 0)">
            <g id="Grupo_101" data-name="Grupo 101">
              <path
                id="Trazado_9101"
                data-name="Trazado 9101"
                d="M15.181,50.92a2.9,2.9,0,0,0-1.031-1.039c0-.062,0-.123,0-.183,0-1.335-1.262-1.611-1.889-1.706a1.505,1.505,0,0,0-.138-.488,1.971,1.971,0,0,0-1.644-1.083l-1.333-.078a1.954,1.954,0,0,0-1.4-.473,1.947,1.947,0,0,0-1.4.475l-1.3.076A1.97,1.97,0,0,0,3.418,47.5a1.5,1.5,0,0,0-.138.488c-.626.1-1.888.372-1.888,1.706,0,.06,0,.121,0,.183a3.016,3.016,0,0,0-1.05,1.034,2.171,2.171,0,0,0-.288,1.667c.229.915,1.507,2.231,3.515,3.625V56.9a1.707,1.707,0,0,0,1.712,1.7,2.28,2.28,0,0,0,1.332-.545c.163.087.325.172.483.253a1.48,1.48,0,0,0,1.345,0c.148-.076.3-.153.441-.23a2.21,2.21,0,0,0,1.3.522,1.7,1.7,0,0,0,1.694-1.7V56.21a18.652,18.652,0,0,0,3.245-2.889h0l.01-.013.005-.007.01-.016,0-.006v0a2.455,2.455,0,0,0,.291-.692A2.24,2.24,0,0,0,15.181,50.92ZM5.286,57.991A1.1,1.1,0,0,1,4.18,56.9v-.283c.578.378,1.192.749,1.837,1.109A1.222,1.222,0,0,1,5.286,57.991ZM11.271,56.9a1.092,1.092,0,0,1-1.088,1.093,1.171,1.171,0,0,1-.7-.246c.614-.348,1.212-.721,1.788-1.112Zm3.585-4.463a1.851,1.851,0,0,1-.218.519A22.371,22.371,0,0,1,8.17,57.766a.872.872,0,0,1-.793,0,31.038,31.038,0,0,1-3.313-1.957C1.775,54.244.8,53.04.647,52.435a1.889,1.889,0,0,1,.841-1.887c.4,1.817,1.952,3.231,3.053,4.352a.3.3,0,1,0,.433-.425C4,53.485,2.2,51.886,2.015,50.023,2,49.914,2,49.8,2,49.7c0-.694.5-.954,1.281-1.091.167,1.735,1.482,4.293,2.071,5.541A.3.3,0,0,0,5.9,53.89C5.48,53,3.85,49.878,3.869,48.26a1.135,1.135,0,0,1,.091-.485A1.363,1.363,0,0,1,5.1,47.026l.854-.05c-.49,1.286.175,3.432.482,5.312a.3.3,0,1,0,.6-.1c-.323-1.978-1.09-4.461-.309-5.349a1.3,1.3,0,0,1,1.034-.365,1.3,1.3,0,0,1,1.034.363c.782.884.014,3.368-.309,5.351a.3.3,0,1,0,.6.1c.307-1.883.973-4.029.483-5.314l.887.052a1.363,1.363,0,0,1,1.137.749,1.138,1.138,0,0,1,.091.486c.019,1.573-1.521,4.555-2.037,5.645a.3.3,0,0,0,.548.259c.393-.832,1.9-3.713,2.079-5.557.777.137,1.281.4,1.281,1.091,0,.106-.006.215-.017.325-.185,1.824-1.872,3.351-2.974,4.469a.3.3,0,0,0,.432.426c.973-.987,2.651-2.485,3.07-4.367A1.88,1.88,0,0,1,14.856,52.435Z"
                transform="translate(0.001 -45.87)"
              />
            </g>
          </g>
        </g>
      </g>
    </SvgWrapper>
  );
};

export default MolluscIcon;
